import React, { useContext } from "react";
import { useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import MailIcon from "@mui/icons-material/Mail";
import { SingleContext, SiteContext } from "gatsby-frontend";

function Share({ buttons, color }) {
	const theme = useTheme();
	const { twitterUsername } = useContext(SiteContext);
	const { slug, title, summary } = useContext(SingleContext);
	const url = `${process.env.GATSBY_SITE_URL}${slug}`;
	const tweet = `${url} ${title} ${
		twitterUsername ? "by @" + twitterUsername : ""
	} `;

	const email = `mailto:?subject=${encodeURIComponent(
		title
	)}&body=${encodeURIComponent(summary)}${encodeURIComponent(
		" \n\n "
	)}${encodeURIComponent(url)}`;

	return (
		<Stack
			direction="row"
			spacing={1}
			sx={{
				margin: theme.spacing(1, 0, 0, -1),
				"& a": {
					color: `${color} !important`,
					"&:after": { display: "none !important" },
				},
			}}
		>
			{buttons.includes("facebook") && (
				<IconButton
					aria-label="Share on Facebook"
					component="a"
					href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
						url
					)}`}
					target="_blank"
					sx={{ marginLeft: `0 !important` }}
				>
					<FacebookIcon sx={{ color: color }} />
				</IconButton>
			)}
			{buttons.includes("twitter") && (
				<IconButton
					aria-label="Share on Twitter"
					component="a"
					href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
						tweet
					)}`}
					target="_blank"
					sx={{ marginLeft: `0 !important` }}
				>
					<TwitterIcon sx={{ color: color }} />
				</IconButton>
			)}
			{buttons.includes("linkedin") && (
				<IconButton
					aria-label="Share on LinkedIn"
					component="a"
					href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
						url
					)}`}
					target="_blank"
					sx={{ marginLeft: `0 !important` }}
				>
					<LinkedInIcon sx={{ color: color }} />
				</IconButton>
			)}
			{buttons.includes("email") && (
				<IconButton
					aria-label="Share by Email"
					component="a"
					href={email}
					target="_blank"
					sx={{ marginLeft: `0 !important` }}
				>
					<MailIcon sx={{ color: color }} />
				</IconButton>
			)}
		</Stack>
	);
}

export default Share;
